import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const HeaderMenuAccountTakeover = props => {
  const [accountId, setAccountId] = useState('');

  const handleIdChange = e => {
    if (props.accountTakenOver) return;
    setAccountId(e.target.value);
  };

  const takeoverAccount = e => {
    e.preventDefault();
    props.switchAccount(props.accountId, accountId);
  };

  useEffect(() => {
    if (props.accountTakenOver && props.accountId !== accountId) {
      setAccountId(props.accountId);
    }
  }, [accountId, props.accountId, props.accountTakenOver]);

  return (
    <div className={styles.accountTakeover}>
      <nbx-field
        input-id="accoundId"
        label="Account Takeover (Admin-Only)"
        value={accountId}
        onKeyUp={handleIdChange}
        placeholder="Account ID"
        readonly={props.accountTakenOver}
      />
      <nbx-button-text
        onClick={takeoverAccount}
        disabled={accountId === '' || props.switchingAccount || props.accountTakenOver}>
        Get Token
      </nbx-button-text>
    </div>
  );
};

HeaderMenuAccountTakeover.propTypes = {
  accountId: PropTypes.string.isRequired,
  accountTakenOver: PropTypes.bool.isRequired,
  switchingAccount: PropTypes.bool.isRequired,
  switchAccount: PropTypes.func.isRequired
};

export default HeaderMenuAccountTakeover;
